export const fetchcategory = async () => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/category-name/`);
    if (!response.ok) {
      throw new Error('Failed to fetch catagory');
    }
    const data = await response.json();
    // Extract brand_name from each brand_details object
    
    return data;
  } catch (error) {
    throw new Error(`API Error: ${error.message}`);
  }
};